import { SideModal } from '@design-system/components/modal/sideModal';
import { extrasVM } from '../Extras.page';
import { LegacyGuideForm } from './legacy-guide.form';
import { formWrapper } from '@client/new/pages/challenges/view/Challenges.view.css';

export const LegacyGuideView = () => {
  const vm = extrasVM.useValue();
  const legacyGuideVM = vm.legacyGuideVM;

  const isOpen = legacyGuideVM.mode === 'edit';

  return (
    <SideModal
      isOpen={isOpen}
      onClose={() => legacyGuideVM.dispatch('Cancel')}
      noSpacing
    >
      <div key={legacyGuideVM.content.id} className={formWrapper}>
        <LegacyGuideForm legacyGuideVM={legacyGuideVM} />
      </div>
    </SideModal>
  );
};
